import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  isToast = false;
  type: 'success' | 'error' | 'warning' | 'info' = 'info';

  header: string = '';
  message: string = '';
  translateY = 'translateY(-100%)';

  isShowing = false;

  constructor() { }

  alert(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') {
    this.message = message;
    this.type = type;
    this.isShowing = true;
    this.isToast = false;

    setTimeout(() => {
      this.translateY = 'translateY(50%)';
    }, 100);
  }

  cleanData() {
    this.header = '';
    this.message = '';
  }

  close() {
    this.translateY = 'translateY(-100%)';

    setTimeout(() => {
      this.isShowing = false;
      this.isToast = false;
      this.cleanData();
    }, 600);
  }

  toast(message: string) {
    console.log('TOAST');

    this.message = message;
    this.type = 'success';
    this.isToast = true;
    this.isShowing = true;

    setTimeout(() => {
      this.close();
    }, 1000);
  }

}
